import type { EnvironmentProviders } from '@angular/core';

// angular.json swaps in store-devtools.dev.ts for the internal build, so
// @ngrx/store-devtools shakes out of the customer bundle instead of shipping dead.
export const storeDevtools: EnvironmentProviders[] = [];
